import { Option } from "../services/dashboard.service";

export const getFilterDashboard = (options?: Option) => {
  if (options && options?.dateFrom && options?.dateTo) {
    return {
      date_to: options?.dateTo,
      date_from: options?.dateFrom,
    };
  }

  return {};
};
